import styled from "styled-components";
import { TopicElement } from "shared/types";

interface Props {
  data: TopicElement;
}

export default function Movie({ data }: Props) {
  return (
    <>
      <Title>{data.text}</Title>
      <YouTubeVideoPlayer
        height="231"
        src={data.siteUrl}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></YouTubeVideoPlayer>
    </>
  );
}

const Title = styled.h5`
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.41px;
  line-height: 28px;
  color: #3c424a;
  margin-bottom: 8px;
`;

const YouTubeVideoPlayer = styled.iframe``;
